(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
  var link = e.target.closest('a[href="#"]');
  if (link && link.closest('.menu-drawer')) {
    e.preventDefault();
  }
});
  } catch(e) { console.error(e); }
})();

})();
